import { tv } from "@pcln/horizon";
const searchFormRadioGroup = tv({
    slots: {
        root: 'flex flex-row flex-wrap items-center gap-3 @lg:gap-4'
    },
    variants: {
        wrap: {
            true: {
                root: 'grid auto-cols-min grid-flow-col grid-cols-[minmax(min-content,1fr)_minmax(min-content,1fr)] grid-rows-2 gap-x-10 gap-y-3 text-nowrap @lg:gap-y-4 @2xl:grid-cols-none @2xl:grid-rows-1 @2xl:gap-4'
            },
            false: {}
        }
    },
    defaultVariants: {
        wrap: false
    }
});
export { searchFormRadioGroup };
